import React from "react";
import { ReactComponent as TWITTER } from "../img/social_icons/twitter.svg";

export const Twitter = () => {
  return <TWITTER title="twitter" />;
};
